export function getFunctionGetWFString(per) {
    return function(wf) {
        if ((wf === null) || (wf === "null") || (wf === "")) {
            return "";
        }
        if (Number(wf) >= 1e9) {
            return (Number(wf) / 1e9) + " 10<sup>9</sup> m<sup>3</sup>/" + per;
        } else if (Number(wf) >= 1e6) {
            return (Number(wf) / 1e6) + " 10<sup>6</sup> m<sup>3</sup>/" + per;
        }
        return wf + " m<sup>3</sup>/" + per;
    }
}

export function getWFtString(wft) {
    if ((wft === null) || (wft === "null") || (wft === "")) {
        return "";
    }
    return wft + " m<sup>3</sup>/t";
}

export function getWSString(ws) {
    if ((ws === null) || (ws === "null") || (ws === "")) {
        return "(unknown)";
    }
    if (Number(ws) < 1.0) {
        return ws + " (low)";
    } else if (Number(ws) < 1.5) {
        return ws + " (moderate)";
    } else if (Number(ws) < 2) {
        return ws + " (significant)";
    }
    return ws + " (severe)"; //  >= 2
}

export function getFunctionGetPercentageString(threshold) {
    return function(per) {
        if ((per === null) || (per === "null") || (per === "")) {
            return "";
        }
        var p = Number(per) * 100;
        if ((p >= 0) && (p < threshold)) {
            return "<" + threshold + "%";
        }
        return Math.round(p) + "%";
    }
}

/*        static public function getYesNoString(item:Object, column:GridColumn):String {
            var yn:String = item[column.dataField];
            if ((yn == null) || (yn == "null") || (yn == "")) {
                return "";
            }
            if (yn == "t") {
                return "YES";
            }
            return "no";
        }
        
        static public function sortCompareNumberStrings(obj0:Object, obj1:Object, column:GridColumn):int {
            var val0:String = obj0[column.dataField];
            if ((val0 == null) || (val0 == "null") || (val0 == "")) {
                val0 = "0";
            }
            var val1:String = obj1[column.dataField];
            if ((val1 == null) || (val1 == "null") || (val1 == "")) {
                val1 = "0";
            }
            if (Number(val0) < Number(val1)) {
                return -1;
            } else if (Number(val0) > Number(val1)) {
                return 1;
            }
            return 0;
        }
        
        static public function getQuantityString(item:Object, column:GridColumn):String {
            var quantity:String = item[column.dataField];
            if ((quantity == null) || (quantity == "null") || (quantity == "")) {
                return "";
            }
            return quantity += " t/yr";
        }
        
        static public function filterIndividualCrops(item:Object):Boolean {
            var cropID:Number = Number(item.cropID);
            if ((cropID < 1000) || (cropID == 1009)) {
                return true;
            }
            return false;
        }
        
        static public function filterIndividualCropsIndustrialDomestic(item:Object):Boolean {
            var cropID:Number = Number(item.cropID);
            if ((cropID < 1000) || (cropID == 1009) || (cropID == 10002) || (cropID == 10003)) {
                return true;
            }
            return false;
        }
        
        static public function getFunctionFilterByCropIDs(cropIDs:Array):Function {
        	return function(item:Object):Boolean {
                var cropID:Number = Number(item.cropID);
        	    for (var i:uint = 0; i < cropIDs.length; i++) {
                    if (Number(cropIDs[i]) == cropID) {
                        return filterIndividualCrops(item);
                    }
        	    }
                return false;
        	}
        }
        
        static public function getFunctionFilterByCropID(filterValue:String):Function {
            return function(item:Object):Boolean {
                return isSelected(filterValue, item);
            }
        }
        
        static private function isSelected(filterValue:String, item:Object):Boolean {
        	if (item.cropID != null) {  // agricultural/crop
                return (filterValue == '100001') || (filterValue == '10001') || (filterValue == item.cropID);
        	} else {  // industrial
                return (filterValue == '100001') || (filterValue == '10002');
        	}
        	return false;
        }*/

export function getFunctionGetCheckImage(checkName) {
    return function (check) {
        if ((check === null) || (check === "null") || (check === "")) {
            return "";
        }
        if (check) {
            return '<img src="/cross.png" title="' + checkName + ': no"/>';
        }
        return '<img src="/check.png" title="' + checkName + ': yes"/>';
    }
}

